// Cross-backend admin login-verify (POST /login). Only referenced by the dormant
// verify-identity/change-email modal flow in account-setting (no persisting API in
// legacy admin-ui either); kept resolvable so the ported component compiles.
import { adminRequest } from './client.js';

const api = {
	create: (params) => adminRequest('POST', '/login', params),
};

export default api;
